module.exports = __webpack_public_path__ + "static/media/Naviglio_Bordeaux.cfd80367.jpg";